import React from 'react';
import ReactDOM from 'react-dom';

import BorderedBox from '../../../../shared/web/layout/BorderedBox';

import styles from './AssigneeFilter.module.scss';
import { CheckboxGroup, FormTemplate } from 'ui-builder';
import { usePlanTasksTypeFilterService, usePlanTasksSmsRecipientFilterService } from 'features/tasks-forms';
import {
  SelectAllFilterOptionsCheckbox,
  SelectAllFilterOptionsCheckboxPortal
} from '../../../../shared/widgets/SelectAllFilterOptionsCheckbox';

export default function SmsEmailRecipientFilter() {
  const container = document.getElementById('filter2');


  const filterService = usePlanTasksSmsRecipientFilterService();

  const typeFilterService = usePlanTasksTypeFilterService();
  const typeFilterValue = typeFilterService.getFilterValue();


  const setFilterValue = (assignees: number[]) => {
    filterService.setFilterValue(assignees);
  };

  const options = filterService.getOptions();

  if (container && options.length > 0 && (
    typeFilterValue?.showEmailTasks || typeFilterValue?.showSmsTasks
  )) {
    return ReactDOM.createPortal(
      <BorderedBox
        title="Email/SMS Recipient"
        className={styles.filter}
        headerRight={(
          <SelectAllFilterOptionsCheckboxPortal source="smsEmailRecipients" />
        )}
        collapsible
        sectionId="email-sms-recipient"
        pageContext="plan-tasks"
      >
        <FormTemplate
          submitFormFunc={async (data) => {
            setFilterValue(data.smsEmailRecipients as number[]);
          }}
          initialData={{
            smsEmailRecipients: filterService.getFilterValue(),
          }}
          submitOnEachChange
          buttons={null}
        >
          <>
            <CheckboxGroup options={options} source="smsEmailRecipients" hideLabel />
            <SelectAllFilterOptionsCheckbox
              allOptions={options.map((o) => o.value)}
              source="smsEmailRecipients"
            />
          </>
        </FormTemplate>
      </BorderedBox>,
      container,
    );
  } else {
    return null;
  }
}
